import type { GlobalFilters } from '@/domains/filters/filter.entity';
import type { SemesterKey } from '@/domains/shared';

/**
 * UseCase para obtener filtros globales por defecto del sistema
 *
 * Responsabilidades:
 * - Calcular el semestre actual basado en el mes (1-5 = S1, 6-12 = S2)
 * - Obtener el año actual del sistema
 * - Retornar filtros globales por defecto (semestre y año actuales)
 */
export class FilterGlobalUseCase {
  /**
   * Calcula el semestre actual según el mes en curso
   */
  private getCurrentSemester(): SemesterKey {
    const currentMonth = new Date().getMonth() + 1;
    return currentMonth < 6 ? 'semestre-1' : 'semestre-2';
  }

  /**
   * Obtiene el año actual del sistema como string
   */
  private getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }

  /**
   * Obtiene filtros globales con valores por defecto (semestre y año actuales)
   */
  getDefaultFilters(): GlobalFilters {
    return {
      semester: this.getCurrentSemester(),
      year: this.getCurrentYear(),
    };
  }
}
